export default __webpack_public_path__ + "static/media/tisana.6580563d.jpg";